const HUB_SERVER_PORT = 3012;

export const getHubServerPort = () => {
  return HUB_SERVER_PORT.toString();
};
